import styled from "styled-components";

export const Div = styled.div``;
export const Span = styled.span`
  color: #5d687e;
  font-size: 10px;
`;
